import { CheckoutAttribute } from './checkout-attribute.interface';

export interface CheckoutContract {
  attributes: CheckoutAttribute[];
  isMultiplan: boolean;
}
